<template>
  <div class="mealBookForm">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">{{ info.name | filterName }}</span>
    </div>
    <div class="content">
      <p class="content-title">餐次信息</p>
      <van-cell title="餐次名称">
        <template #right-icon>
          <div style="width: 70%; text-align: right">
            {{ info.name }}
          </div>
        </template>
      </van-cell>
      <van-cell title="计费规则">
        <template #right-icon>
          {{ info.chargingMoney }}元/次
        </template>
      </van-cell>
      <van-cell title="确认时间">
        <template #right-icon>
          {{ info.bookingLimitTime }}
        </template>
      </van-cell>
      <div class="itemClass">
        <div class="meetingItem">
          <div>餐次时间</div>
          <div>
            {{ filterTime(info) }}
            <br v-if="filterTime(info).length > 8">
            {{ info.mealTimeStart }}~{{ info.mealTimeEnd }}
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <p class="content-title">订餐信息</p>
      <van-cell required title="用餐区域" is-link @click="showArea = true">
        <template #right-icon>
          <span style="display: flex; align-items: center">
            {{ dataForm.zoneText }}
            <van-icon name="arrow" class="search-icon" />
          </span>
        </template>
      </van-cell>
      <van-cell required title="用餐时间" is-link @click="showDate = true">
        <template #right-icon>
          <span style="display: flex; align-items: center">
            {{ dataForm.bookingDate }}
            <van-icon name="arrow" class="search-icon" />
          </span>
        </template>
      </van-cell>
      <van-cell title="内部用餐人" is-link @click="addStaff">
        <template #right-icon>
          <span style="display: flex; align-items: center">
            {{ inners.length }}人
            <van-icon name="arrow" class="search-icon" />
          </span>
        </template>
      </van-cell>
      <van-cell title="外部用餐人">
        <template #right-icon>
          <van-stepper v-model="dataForm.outerPersonNumber" min="0" @change="changeDataForm" />
        </template>
      </van-cell>
    </div>
    <div class="content">
      <p class="content-title">
        支付方式
      </p>
      <van-cell required title="支付方式" is-link @click="showPay = true">
        <template #right-icon>
          <span style="display: flex; align-items: center">
            {{ dataForm.payText }}
            <van-icon name="arrow" class="search-icon" />
          </span>
        </template>
      </van-cell>
      <van-cell v-if="dataForm.payType === 'COUPON_PAY'" required is-link title="选择卡券" @click="showCoupon = true">
        <template #right-icon>
          <span style="display: flex; align-items: center">
            {{ dataForm.couponName }}
            <van-icon name="arrow" class="search-icon" />
          </span>
        </template>
      </van-cell>
    </div>
    <van-button
      :disabled="filterBtn()"
      class="sub_btn"
      type="info"
      @click="onConfirmBook"
    >确认订餐</van-button>
    <van-popup v-model="showArea" position="bottom" :style="{ height: '50%' }">
      <van-picker
        title="消费区域"
        show-toolbar
        value-key="text"
        :columns="columns"
        :default-index="dataForm.zoneIndex"
        @confirm="onConfirm"
        @cancel="showArea = false"
      />
    </van-popup>
    <van-popup v-model="showPay" position="bottom" :style="{ height: '50%' }">
      <van-picker
        title="支付方式"
        show-toolbar
        value-key="text"
        :columns="payColumns"
        :default-index="dataForm.payIndex"
        @confirm="onConfirmPay"
        @cancel="showPay = false"
      />
    </van-popup>
    <van-calendar v-model="showDate" :max-date="bookMaxDate" @confirm="onConfirmDate" />
    <van-popup
      v-model="showCoupon"
      round
      position="bottom"
      style="height: 60%; padding-top: 4px;"
      class="popup"
    >
      <div v-for="item in list" :key="item.id" class="couponListItem">
        <div class="circle leftCircle" />
        <div class="circle rightCircle" />
        <div class="top">
          <div class="right">
            <div class="name">
              <div class="up">
                <span class="value">{{ item.deductionTimes || item.deductionFee }}</span>
                <span class="unit">{{ item.consumeType === 'COST_PER_TIMES' ? '次' : '元' }}</span>
              </div>
              <div class="bottom">
                {{ item.consumeType === 'COST_PER_TIMES' ? '次数抵扣券' : '金额满减券' }}
              </div>
            </div>
            <div class="value">
              <div class="up">{{ item.couponName }}</div>
              <div class="down">可用时间：{{ item.usingStart }}~{{ item.usingEnd }}</div>
            </div>
          </div>
          <div class="left">
            <van-radio-group v-model="dataForm.couponId">
              <van-radio :name="item.id" @click="() => useCoupon(item.couponName)" />
            </van-radio-group>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { bookingApply, consumeCoupons, mealInfo } from '@/api/user';
import moment from 'moment';
import help from '@/common/help';
export default {
  name: 'MealBookForm',
  filters: {
    filterName(val) {
      if (val.length > 12) {
        let str = '';
        str = val.substring(0, 12) + '...';
        return str;
      } else {
        return val;
      }
    }
  },
  data() {
    return {
      showArea: false,
      showDate: false,
      showCoupon: false,
      showPay: false,
      bookMaxDate: new Date(),
      info: {
        payTypes: [],
        name: ''
      },
      dataForm: {
        zoneId: '',
        payText: '',
        zoneText: '',
        zoneIndex: '',
        payIndex: '',
        mealRuleId: '',
        bookingDate: '',
        payType: '',
        innerPersonIds: [],
        outerPersonNumber: 0,
        couponId: '',
        couponName: ''
      },
      keys: ['zoneId', 'bookingDate', 'payType'],
      list: [],
      columns: [],
      payColumns: [],
      inners: this.$store.state.checkboxStaff
    };
  },
  computed: {
    mealBookForm() {
      this.dataForm = this.$store.state.mealBookForm;
      return this.$store.state.mealBookForm;
    }
  },
  watch: {
    mealBookForm() {}
  },
  created() {
    this.getInfo();
  },
  methods: {
    filterTime(e) {
      const data = [];
      const list = [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
      ];
      list.forEach((item) => {
        if (e[item]) {
          data.push(this.zh.zhCN.week[item]);
        }
      });
      return data.join('、');
    },
    getInfo() {
      mealInfo({ id: this.$route.query.id }).then(res => {
        this.info = res.data;
        // {{ info.bookingLimitTime }}
        const columns = [];
        res.data.zones.forEach(item => {
          const data = { text: item.zoneName, value: item.zoneId };
          columns.push(data);
        });
        this.bookMaxDate = new Date(moment().add(res.data.allowBookingDays - 1, 'days').format('YYYY-MM-DD'));
        const list = this.zh.GetObjectList('payTypes');
        const payColumns = [];
        list.forEach(item => {
          if (res.data.payTypes.includes(item.value)) {
            const data = { text: item.label, value: item.value };
            payColumns.push(data);
          }
        });
        this.columns = columns;
        this.payColumns = payColumns;
      });
      consumeCoupons({}).then(res => {
        this.list = res.data;
      });
    },
    goBack() {
      this.$router.push({ name: 'mealBook' });
      this.$store.dispatch('clearMealBookForm');
    },
    onConfirm(value, index) {
      this.showArea = false;
      this.dataForm.zoneId = value.value;
      this.dataForm.zoneText = value.text;
      this.dataForm.zoneIndex = index;
      this.changeDataForm();
    },
    onConfirmPay(value, index) {
      this.showPay = false;
      this.dataForm.payType = value.value;
      this.dataForm.payText = value.text;
      this.dataForm.payIndex = index;
      if (this.dataForm.payType === 'COUPON_PAY') {
        this.keys.push('couponId');
      }
      this.changeDataForm();
    },
    onConfirmDate(date) {
      this.dataForm.bookingDate = moment(date).format('YYYY-MM-DD');
      this.showDate = false;
      this.changeDataForm();
    },
    addStaff() {
      this.$router.push({ name: 'checkboxStaff', query: { title: '选择用户', from: 'mealBookForm', id: this.$route.query.id }});
    },
    unUseCoupon() {
      this.showCoupon = false;
      this.dataForm.couponId = '';
      this.dataForm.couponName = '';
    },
    useCoupon(name) {
      this.showCoupon = false;
      this.dataForm.couponName = name;
      this.changeDataForm();
    },
    filterBtn() {
      const keys = this.keys;
      return !help.checkForm(keys, this.dataForm);
    },
    changeDataForm() {
      this.$store.dispatch('setMealBookForm', { data: this.dataForm });
    },
    onConfirmBook() {
      // this.$toast.loading({
      //   message: '提交中...',
      //   forbidClick: true,
      //   loadingType: 'spinner',
      //   duration: 0
      // });
      this.dataForm.mealRuleId = this.$route.query.id;
      this.dataForm.innerPersonIds = this.inners;
      bookingApply(this.dataForm).then(res => {
        if (res.code === 200) {
          this.$toast.clear();
          this.$router.push({ name: 'success', query: { from: 'mealBookForm' }});
          this.$store.dispatch('setBookingLimitTime', { data: { bookingLimitTime: this.info.bookingLimitTime, payType: this.dataForm.payType }}); // 成功页面显示下确认时间
          this.$store.dispatch('clearMealBookForm');
        } else {
          this.$toast.clear();
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.change_val(@name, @px){
    @{name}: @px / 200.6 * 1rem;
}
.change_margin(@name, @top, @right){
    @{name}: @top / 200.6 * 1rem @right / 200.6 * 1rem;
}

  .mealBookForm {
  padding-bottom: 10px;
    .couponListItem {
      background: #FFFFFF;
      border: 1px solid #EFEFF4;
      box-shadow: 0px 3px 6px rgba(51, 51, 51, 0.1);
      opacity: 1;
      border-radius: 6px;
      position: relative;
      .change_val(margin, 16);
      .circle {
        position: absolute;
        //.change_val(width, 25);
        //.change_val(height, 25);
        width: 6px;
        height: 8px;
        background-color: #efeff4;

      }

      .leftCircle {
        left: -3px;
        .change_val(bottom, 25);
        border-right: 1px solid #3B86FF;
        border-radius: 0 8px 8px 0;
      }

      .rightCircle {
        right: -3px;
        .change_val(bottom, 25);
        border-left: 1px solid #3B86FF;
        border-radius: 8px 0 0 8px;
      }

      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 2px solid #3B86FF;
        border-top: 1px solid #3B86FF;
        border-right: 1px solid #3B86FF;
        border-left: 1px solid #3B86FF;
        opacity: 1;

        .change_margin(padding, 22, 38);
        .change_val(padding-bottom, 55);
        .right {
          display: flex;
          .name {
            text-align: center;
            display: flex;
            flex-direction: column;
            border-right: 1px dashed #3B86FF;
            .change_val(padding-right, 32);
            .up {
              .value {
                font-weight: 400;
                //font-size: 44px;
                .change_val(font-size, 44);
                .change_val(line-height, 62);
                color: #3B86FF;
              }

              .unit {
                font-weight: 400;
                //font-size: 20px;
                .change_val(font-size, 20);
                .change_val(line-height, 28);
                .change_val(margin-left, 4);
                color: #3B86FF;
              }
            }

            .bottom {
              .change_val(font-size, 20);
              .change_val(line-height, 28);
              .change_val(margin-left, 4);
              font-weight: 400;
              color: #3B86FF;
              opacity: 1;
            }

          }

          .value {
            .change_val(padding-left, 32);

            .up {
              .change_val(font-size, 32);
              .change_val(line-height, 45);
              font-weight: 400;
              color: #333333;
              opacity: 1;
            }

            .down {
              .change_val(font-size, 20);
              .change_val(line-height, 28);
              .change_val(margin-top, 14);
              font-weight: 400;
              color: rgba(0, 0, 0, 0.45);
              opacity: 1;
            }
          }
        }
        .left {

          display: flex;
          justify-content: center;
          align-items: center;
          //color: #3B86FF;
        }
      }

    }

    .content {
      padding-bottom: 0.15rem;
      position: relative;
      .inviteWechatShare {
        background-color: #57c55f;
        border-radius: 100%;
        padding: 5px;
      }
      .inviteCopyShare {
        margin-left: 0.02rem;
        background-color: #3b86ff;
        border-radius: 100%;
        padding: 5px;
      }
      .signIn {
        position: absolute;
        top: -10px;
        right: 10px;
        z-index: 19999;
      }
      .content-title,
      .visitStatus {
        height: 0.45rem;
        line-height: 0.45rem;
        padding: 0rem 0.15rem;

        .subTitle {
          font-size: 0.09rem;
          font-family: PingFang SC;
          font-weight: 400;
          line-height:0.09rem;
          color: #F2B230;
          opacity: 1;
        }

      }
      .content-detail,
      .content-reason {
        font-size: 0.17rem;
        color: #333;
        background: #fff;
        padding: 0.18rem 0.15rem;
      }
      .content-detail p:not(:last-child) {
        margin-bottom: 0.1rem;
      }
      .content-reason {
        padding: 0rem 0.15rem;
        .content-reasonItem {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 0.55rem;
          line-height: 0.55rem;
          .faceImg {
            width: 0.33rem;
            height: 0.33rem;
            line-height: 0.33rem;
            .svg-icon {
              width: 100%;
              height: 100%;
            }
            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
        }
        .content-reasonItem:not(:last-child) {
          border-bottom: 1px solid #e5e5e5;
        }
      }
      .has-small-magb{
        position: relative;
        margin-bottom: 0.1rem;
        .content-reasonItem[class~='has-status']{
          height:0.73rem;
        }
        .tip-status{
          width: 0.65rem;
          height: 0.2rem;
          line-height: 0.2rem;
          text-align: center;
          border-radius: 14px 0px 0px 14px;
          color: #fff;
          font-size: .14rem;
          position: absolute;
          right: 0px;
          &.CANCEL,
          &.UNVISIT,
          &.AUDIT_FAIL,
          &.OUTTIME_AUDIT {
            background-color: rgba(51, 51, 51, 0.5);
          }

          &.WAITING_AUDIT,
          &.WAITING_VERIFY {
            background-color: #f2b230;
          }

          &.OUTTIME_VISIT,
          &.AUDIT_REJECT {
            background-color: #f76260;
          }

          &.VISITING,
          &.WAITING_VISIT {
            background-color: #3b86ff;
          }

          &.FINISH,
          &.AUDIT_PASSED {
            background-color: #2dcc2c;
          }
        }

      }

      .itemClass {
        background-color: #FFFFFF;
        padding: 0.145rem 0.16rem 0 0.145rem;
        .meetingItem {
          padding-bottom: 0.16rem;
          font-size: 0.16rem;
          color: #333333;
          border-bottom: 1px solid #ebedf0;
        }
      }
    }

    .popup {
      .btnArea {
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        .change_margin(padding, 45, 45);
        .btn {
          background-color: #e20c26;
          color: #FFFFFF;
          border-radius: 999px;
          text-align: center;
          .change_margin(padding, 15, 30);
        }
      }
    }

  }
</style>
